export const CAPTURE_LABEL_KEY: Record<string, string> = {
  online: "payfac.pageRatePlanModalTabOnline",
  pos: "payfac.pageRatePlanModalTabPos",
  tap: "payfac.pageRatePlanModalTabTap",
};

export const BRAND_LABEL_KEY: Record<string, string> = {
  default: "payfac.pageRatePlanModalNetworkDefault",
  mastercard: "payfac.pageRatePlanModalNetworkMastercard",
  visa: "payfac.pageRatePlanModalNetworkVisa",
  elo: "payfac.pageRatePlanModalNetworkElo",
  hipercard: "payfac.pageRatePlanModalNetworkHipercard",
  american_express: "payfac.pageRatePlanModalNetworkAmericanExpress",
  americanExpress: "payfac.pageRatePlanModalNetworkAmericanExpress",
  discover: "payfac.pageRatePlanModalNetworkDiscover",
};

export const VALUE_COLUMN_LABEL_KEY_BY_VERSION: Record<"1" | "2", string> = {
  "1": "payfac.pageRatePlanHistoryModalInstallmentsColumnMarkup",
  "2": "payfac.pageRatePlanHistoryModalInstallmentsColumnAggregated",
};
